import { useState, useCallback, useRef } from "react";
import { AgreementHandlerKey } from "../context/AgreementContext";

export const useAgreementDialog = () => {
  const [dialogHandlerKey, setDialogHandlerKey] =
    useState<AgreementHandlerKey | null>(null);
  const dialogConfirmCallback = useRef<(() => void) | null>(null);

  const openDialog = useCallback(
    (handlerKey: AgreementHandlerKey, onConfirm: () => void) => {
      setDialogHandlerKey(handlerKey);
      dialogConfirmCallback.current = onConfirm;
    },
    [],
  );

  const closeDialog = useCallback(() => {
    setDialogHandlerKey(null);
    dialogConfirmCallback.current = null;
  }, []);

  const confirmDialog = useCallback(() => {
    if (dialogConfirmCallback.current) {
      dialogConfirmCallback.current();
    }
  }, []);

  return {
    dialogHandlerKey,
    openDialog,
    closeDialog,
    confirmDialog,
  };
};
